<template>
  <div class="page-protocal">
    <h1 class="title">{{ title }}</h1>
    <div class="content reset-rich-text" v-html="detail"></div>
  </div>
</template>
<script>
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { protocolAPI } from "@/api/protocol";
import { checkResponse } from "@/assets/js/utils";
import { PROTOCOL_TYPE } from "@/assets/js/config";
export default {
  name: "Protocal",
  data() {
    return {
      type: -1,
      title: "",
      detail: "",
    };
  },
  mounted() {
    let type = this.$route.params.type;
    if (type != null && typeof type != "undefined") {
      this.type = type;
      this.requestData(type);
      let typeTitle = PROTOCOL_TYPE[type];
      if (typeTitle) {
        BridgeNativeMethods.setTitle(typeTitle);
      }
    }
  },
  methods: {
    requestData() {
      protocolAPI().then(
        (response) => {
          if (checkResponse(response)) {
            let data = response.data;
            if (data && data.length > 0) {
              let protocol = data.find(item => {
                  if(item.type == this.type) {
                      return true;
                  }
              });
              if(protocol != null) {
                  this.title = protocol.name;
                  this.detail = protocol.content;
              }
            }
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          BridgeNativeMethods.showToast("请求错误");
          console.log(err);
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.page-protocal{
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 12px;
}
.title {
    font-size: 18px;
    line-height: 67px;
    margin:0;
    padding:0;
    text-align: center;
}
</style>